export default __webpack_public_path__ + "static/media/viremini.2087d7d1.jpg";